import React, { useEffect, useState, useCallback } from "react";
import {
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getemloyeeforinsert,
  getEmployee,
  getEmployeeType,
  getGenders,
  getGroup,
  getPayScale,
  getProfitCenter,
  getShift,
  insertEmployee,
  getEmpStatus,
  insertemployeedocuments,
  getDocumentsType,
  getAllEmployee,
} from "../../services/dataService";
import toast from "react-hot-toast";
import { IconLogicNand } from "@tabler/icons-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Cropper from "react-easy-crop";
import { IMAGE_URL } from "../../services/apiGateway";
import { getSecureItem } from "../../services/SecureStorage";

function EmployeeDetails({ EmpId, onClose }) {
  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const UID = getSecureItem("userId");
  const [company, setCompany] = useState([]);
  const [profitCenter, setProfitCenter] = useState([]);
  const [department, setDepartment] = useState([]);
  const [group, setGroup] = useState([]);
  const [category, setCategory] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [payScale, setPayScale] = useState([]);
  const [employeeType, setEmployeeType] = useState([]);
  const [employeeRights, setEmployeeRights] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [errors, setErrors] = useState({});
  const [MobilePunch, setMobilePunch] = useState(false);
  const [isEdit, SetIsEdit] = useState(true);

  const [isTabEnabled, setIsTabEnabled] = useState(true);
  const ClearEmployeeData = () => {
    setEmployeeDetails({
      Name: "",
      Code: "",
      EmployeeId: "",
      GenderId: "",
      DOJ: "",
      DOB: "",
      AadharNo: "",
      DOR: "",
      ProfitCenterId: "",
      DepartmentId: "",
      CategoryId: "",
      GroupId: "",
      DesignationId: "",
      EmployTypeId: "",
      PayScaleId: "",
      SalaryGeneration: "",
      ContractEndDate: "",
      UserId: UID,
      DepartmentName: "",
      ProfitcenterName: "",
      Mobile2: "",
      Mobile: "",
      Email: "",
      CompanyId: "",
      ShiftId: "",
      EmpStatus: "",
      Narration: "",
      MobilePunch: false,
      DutyAllocation: false,
      directHalfday: "",
    });
  };

  const [shiftData, setShiftData] = useState([]);

  const fetchShifts = async () => {
    try {
      const data = await getShift(UID);
      setShiftData(data.data.data);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  // Image and Cropping Section
  const [documentType, setDocumnetType] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const [formData, setFormData] = useState({
    Id: "",
    DocId: "",
    Doc: { file: null, previewUrl: "" },
    DocDescription: "",
    UserId: UID,
  });

  // Utility function to crop image (defined inside the component)
  const getCroppedImg = async (imageSrc, crop, zoom, rotation = 0) => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio || 1;
    const { width: cropWidth, height: cropHeight } = crop;

    canvas.width = cropWidth * pixelRatio;
    canvas.height = cropHeight * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.translate(cropWidth / 2, cropHeight / 2);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.translate(-cropWidth / 2, -cropHeight / 2);

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight,
    );

    return canvas.toDataURL("image/jpeg");
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      DocId: documentType.find((el) => el.Name === "Photo")?.Id || "",
    }));
  }, [documentType]);

  useEffect(() => {
    const fetchDocTypes = async () => {
      setLoading(true);
      try {
        const response = await getDocumentsType(UID);
        if (response?.data?.data) {
          setDocumnetType(response.data.data);
        } else {
          console.warn("Unexpected API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching document types:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocTypes();
  }, [UID]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file" && files[0]) {
      const file = files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prevState) => ({
          ...prevState,
          [name]: {
            file,
            previewUrl: reader.result,
          },
        }));
        setCroppedImage(null); // Reset cropped image when new file is selected
      };

      reader.readAsDataURL(file);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = useCallback(async () => {
    try {
      const croppedImageUrl = await getCroppedImg(
        formData.Doc.previewUrl,
        croppedAreaPixels,
        zoom,
      );
      setCroppedImage(croppedImageUrl);
    } catch (e) {
      console.error("Error cropping image:", e);
    }
  }, [croppedAreaPixels, zoom, formData.Doc.previewUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!formData.Doc?.file) {
        toast.error("Please select an image to upload.");
        setLoading(false);
        return;
      }

      // Use cropped image if available, otherwise use original
      const imageToUpload = croppedImage || formData.Doc.previewUrl;

      const data = {
        ...formData,
        Doc: imageToUpload,
        EmpId,
      };

      const response = await insertemployeedocuments(data);

      if (response?.data?.StatusCode === 200) {
        toast.success("Document uploaded successfully.");
        setIsModalOpen(false);
      } else {
        toast.error(response?.data?.Message || "Failed to upload document.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Please submit the fields first.");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const [empType, setEmpType] = useState([]);
  const fetchEmpType = async () => {
    try {
      const data = await getEmpStatus(UID);
      setEmpType(data.data.data);
    } catch (error) {
      console.error("Error fetching employee status", error);
    }
  };

  useEffect(() => {
    fetchEmpType();
  }, []);

  const handleEmployeeDetailsSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const Data = {
      ...employeeDetails,
      UserId: UID,
    };

    try {
      const response = await insertEmployee(Data);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        onClose();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Email")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while adding Employee.");
      }
      console.error("Error adding Employee:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getemployee = async () => {
      try {
        const response = await getAllEmployee(UID);
        if (response?.data) {
          const data = response.data.data.find((el) => el.Id === EmpId);
          if (data) {            
            setEmployeeDetails(data);
          } else {
            console.warn(
              "No Employee Details found for the given employee ID.",
            );
          }
        } else {
          console.warn("Response data is empty or undefined.");
        }
      } catch (error) {
        console.error("Error fetching personal details:", error);
      }
    };

    getemployee();
  }, [UID, EmpId]);

  useEffect(() => {
    if (isTabEnabled) {
      setLoading(true);
      const fetchData = async () => {
        try {
          const [
            employeeRightsResponse,
            categoryResponse,
            departmentResponse,
            groupResponse,
            companyResponse,
            profitCenterResponse,
            designationResponse,
            employeeTypeResponse,
            payScaleResponse,
            genderResponse,
          ] = await Promise.all([
            getemloyeeforinsert(UID),
            getCategorys(UID),
            getDepartments(UID),
            getGroup(UID),
            getCompanys(UID),
            getProfitCenter(UID),
            getDesignation(UID),
            getEmployeeType(UID),
            getPayScale(UID),
            getGenders(UID),
          ]);

          setEmployeeRights(employeeRightsResponse?.data?.data);
          setCategory(categoryResponse?.data?.data);
          setDepartment(departmentResponse?.data?.data);
          setGroup(groupResponse?.data?.data);
          setCompany(companyResponse?.data?.data);
          setProfitCenter(profitCenterResponse?.data?.data);
          setDesignation(designationResponse?.data?.data);
          setEmployeeType(employeeTypeResponse?.data?.data);
          setPayScale(payScaleResponse?.data?.data);
          setGender(genderResponse?.data?.data || []);
          setLoading(false);
        } catch (err) {
          console.error("Error fetching data:", err);
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [UID, isTabEnabled]);

  const validateInput = (name, value) => {
    let error = "";

    if (name === "AadharNo") {
      if (!/^\d{12}$/.test(value)) {
        error = "Aadhaar number must be 12 digits";
      }
    }

    if (name === "Mobile") {
      if (!/^(?:\d{10}|91\d{10})$/.test(value)) {
        error = "Mobile number must be 10 digits or 12 digits starting with 91";
      }
    }

    if (name === "Mobile2") {
      if (value && !/^(?:\d{10}|91\d{10})$/.test(value)) {
        error = "Mobile number must be 10 digits or 12 digits starting with 91";
      }
    }

    return error;
  };

  if (loading) {
    return (
      <div className="skeleton-container">
        {[...Array(6)]?.map((_, rowIndex) => (
          <div
            className="skeleton-row"
            key={rowIndex}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "1rem",
              marginBottom: "1rem",
            }}
          >
            <Skeleton height={50} width="100%" />
            <Skeleton height={50} width="100%" />
            <Skeleton height={50} width="100%" />
          </div>
        ))}
        <div
          className="skeleton-row"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "1rem",
          }}
        >
          <Skeleton height={50} width="100%" />
          <Skeleton height={50} width="100%" />
        </div>
      </div>
    );
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const error = validateInput(name, value);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    setEmployeeDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleIsEdit = () => {
    SetIsEdit(!isEdit);
  };

  return (
    <div>
      <form onSubmit={handleEmployeeDetailsSubmit}>
        <div className="my-10 md:px-10 px-[7px] max-h-[80vh] overflow-auto cus-scrollbar">
          {employeeDetails.Id ? (
            <>
              <div className="relative bg-red-500 h-[100px] w-[100px] rounded-full border-2 border-white flex items-center justify-center overflow-hidden group">
                {employeeDetails.ProfilePicture ? (
                  <>
                    <img
                      src={`${IMAGE_URL}/${employeeDetails.ProfilePicture}`}
                      alt="Profile"
                      className="h-full w-full object-cover rounded-full"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <span
                        onClick={() => {
                          if (!isEdit) {
                            setIsModalOpen(true);
                          }
                        }}
                        className={`text-white text-sm font-bold cursor-pointer ${isEdit ? "cursor-not-allowed opacity-50" : ""}`}
                      >
                        Change Photo
                      </span>
                    </div>
                  </>
                ) : (
                  <span
                    onClick={() => {
                      if (!isEdit) {
                        setIsModalOpen(true);
                      }
                    }}
                    className={`text-white text-sm font-bold cursor-pointer ${isEdit ? "cursor-not-allowed opacity-50" : ""}`}
                  >
                    Add Photo
                  </span>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          <div className="flex justify-end">
            <button
              className="btn btn-success"
              type="button"
              onClick={handleIsEdit}
            >
              {isEdit ? "Enable Edit Mode" : "Disable Edit Mode"}
            </button>
          </div>

          {isModalOpen && (
            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex items-center justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0">
                <div
                  className="fixed inset-0 transition-opacity"
                  aria-hidden="true"
                >
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="flex justify-between items-center">
                      <h3 className="text-lg leading-6 font-medium text-gray-900">
                        {employeeDetails.ProfilePicture
                          ? "Change Profile Picture"
                          : "Add Profile Picture"}
                      </h3>
                      <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="text-gray-400 hover:text-gray-500 focus:outline-none"
                      >
                        <span className="sr-only">Close</span>
                        <svg
                          className="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                    <form
                      className="space-y-4 mt-4"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div>
                        <label
                          htmlFor="Doc"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Upload Image
                        </label>
                        <input
                          type="file"
                          id="Doc"
                          name="Doc"
                          accept=".jpg,.png,.jpeg"
                          onChange={handleChange}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        />
                      </div>
                      {formData.Doc.previewUrl && (
                        <div className="mt-4">
                          <div className="relative" style={{ height: "300px" }}>
                            <Cropper
                              image={formData.Doc.previewUrl}
                              crop={crop}
                              zoom={zoom}
                              aspect={1}
                              onCropChange={setCrop}
                              onZoomChange={setZoom}
                              onCropComplete={onCropComplete}
                              cropShape="round"
                              showGrid={false}
                            />
                          </div>
                          <div className="mt-2">
                            <label
                              htmlFor="zoom"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Zoom
                            </label>
                            <input
                              type="range"
                              id="zoom"
                              min={1}
                              max={3}
                              step={0.1}
                              value={zoom}
                              onChange={(e) => setZoom(Number(e.target.value))}
                              className="w-full"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={handleCrop}
                            className="mt-2 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
                          >
                            Crop Image
                          </button>
                          {croppedImage && (
                            <div className="mt-4">
                              <p className="text-sm font-medium text-gray-700">
                                Cropped Preview:
                              </p>
                              <img
                                src={croppedImage}
                                alt="Cropped"
                                className="mt-2 h-24 w-24 rounded-full object-cover"
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div>
                        <label
                          htmlFor="DocDescription"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Image Description
                        </label>
                        <textarea
                          id="DocDescription"
                          name="DocDescription"
                          disabled={isEdit}
                          value={formData.DocDescription}
                          onChange={handleChange}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        ></textarea>
                      </div>
                      <div className="flex justify-end space-x-2">
                        <button
                          type="button"
                          onClick={() => setIsModalOpen(false)}
                          className="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleSubmit}
                          type="button"
                          className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="grid grid-cols-12 gap-20">
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Name <span style={{ color: "red" }}> *</span>
              </label>
              <input
                type="text"
                name="Name"
                required
                disabled={isEdit}
                value={employeeDetails?.Name}
                onChange={handleInputChange}
                placeholder="Name"
                onBlur={(e) => {
                  handleInputChange({
                    target: { name: "Name", value: e.target.value.trim() },
                  });
                }}
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Employee Code (Biometric Code)
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="number"
                name="Code"
                disabled={isEdit}
                required
                value={employeeDetails?.Code}
                onChange={handleInputChange}
                onWheel={(e) => e.target.blur()}
                placeholder="Code"
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Gender <span style={{ color: "red" }}> *</span>
              </label>
              <select
                name="GenderId"
                disabled={isEdit}
                value={employeeDetails?.GenderId}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Gender</option>
                {gender?.map((g) => (
                  <option key={g.value} value={g.Id}>
                    {g.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Date of birth<span style={{ color: "red" }}> *</span>
              </label>
              <input
                disabled={isEdit}
                type="date"
                id="DOB"
                name="DOB"
                value={
                  employeeDetails?.DOB
                    ? new Date(employeeDetails?.DOB).toISOString().split("T")[0]
                    : ""
                }
                onChange={handleInputChange}
                placeholder="Date of birth"
                max={new Date().toISOString().split("T")[0]}
                required
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Aadhar No<span style={{ color: "red" }}> *</span>
              </label>
              <input
                type="number"
                disabled={isEdit}
                id="AadharNo"
                name="AadharNo"
                value={employeeDetails.AadharNo}
                onInput={(e) => {
                  if (e.target.value.length > 12)
                    e.target.value = e.target.value.slice(0, 12);
                }}
                onChange={handleInputChange}
                placeholder="Aadhar No"
                required
                className={`w-full p-2 border rounded ${errors.AadharNo ? "border-red-500" : ""}`}
                onWheel={(e) => e.target.blur()}
              />
              {errors.AadharNo && (
                <p className="text-red-500 mt-1">{errors.AadharNo}</p>
              )}
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Date of Joining</label>
              <input
                type="date"
                name="DOJ"
                value={
                  employeeDetails?.DOJ
                    ? new Date(employeeDetails?.DOJ).toISOString().split("T")[0]
                    : ""
                }
                onChange={handleInputChange}
                placeholder="Date of Joining"
                max={new Date().toISOString().split("T")[0]}
                disabled={isEdit}
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Date of Retirement</label>
              <input
                type="date"
                name="DOR"
                value={
                  employeeDetails?.DOR
                    ? new Date(employeeDetails?.DOR).toISOString().split("T")[0]
                    : ""
                }
                disabled={isEdit}
                onChange={handleInputChange}
                placeholder="Date of Retirement"
                min={employeeDetails?.DOJ}
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Increment date</label>
              <input
                type="date"
                name="IncrementDate"
                disabled={isEdit}
                value={
                  employeeDetails?.IncrementDate
                    ? new Date(employeeDetails?.IncrementDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleInputChange}
                placeholder="Increment Date"
                min={employeeDetails?.DOJ}
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Contract End Date</label>
              <input
                disabled={isEdit}
                type="date"
                name="ContractEndDate"
                value={
                  employeeDetails?.ContractEndDate
                    ? new Date(employeeDetails?.ContractEndDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleInputChange}
                min={employeeDetails?.DOJ}
                placeholder="Contract EndDate"
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Email</label>
              <input
                disabled={isEdit}
                type="email"
                name="Email"
                value={employeeDetails?.Email}
                onChange={handleInputChange}
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Mobile <span style={{ color: "red" }}> *</span>
              </label>
              <input
                disabled={isEdit}
                type="number"
                name="Mobile"
                value={employeeDetails?.Mobile || ""}
                onChange={handleInputChange}
                placeholder="Mobile"
                onWheel={(e) => e.target.blur()}
                required
              />
              {errors.Mobile && (
                <p style={{ color: "red", fontSize: "0.875rem" }}>
                  {errors.Mobile}
                </p>
              )}
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Alternate Mobile No</label>
              <input
                disabled={isEdit}
                type="number"
                name="Mobile2"
                value={employeeDetails?.Mobile2 || ""}
                onChange={handleInputChange}
                onWheel={(e) => e.target.blur()}
                placeholder="Alternate Mobile No"
              />
              {errors.Mobile2 && (
                <p style={{ color: "red", fontSize: "0.875rem" }}>
                  {errors.Mobile2}
                </p>
              )}
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Company <span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="CompanyId"
                value={employeeDetails?.CompanyId}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode ? employeeDetails?.CompanyName : "Select Company"}
                </option>
                {company?.map((g) => (
                  <option key={g.value} value={g.Id}>
                    {g.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Profit Center <span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="ProfitCenterId"
                value={employeeDetails?.ProfitCenterId}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode
                    ? employeeDetails?.ProfitCenterId
                    : "Select Profit Center"}
                </option>
                {profitCenter
                  ?.filter((el) => el?.CompanyId === employeeDetails?.CompanyId)
                  ?.map((g) => (
                    <option key={g.value} value={g.Id}>
                      {g.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Department<span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="DepartmentId"
                value={employeeDetails?.DepartmentId}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode
                    ? employeeDetails?.DepartmentName
                    : "Select Department"}
                </option>
                {department
                  ?.filter(
                    (el) => el.CommonDataId === employeeDetails?.ProfitCenterId,
                  )
                  ?.map((g) => (
                    <option key={g.value} value={g.Id}>
                      {g.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Category <span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="CategoryId"
                value={employeeDetails?.CategoryId}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode
                    ? employeeDetails?.CategoryName
                    : "Select Category"}
                </option>
                {category?.map((g) => (
                  <option key={g.Id} value={g.Id}>
                    {g.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>Group</label>
              <select
                disabled={isEdit}
                name="GroupId"
                value={employeeDetails?.GroupId}
                onChange={handleInputChange}
              >
                <option value="">
                  {isEditMode ? employeeDetails?.GroupName : "Select Group"}
                </option>
                {group?.map((g) => (
                  <option key={g.value} value={g.Id}>
                    {g.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Designation <span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="DesignationId"
                value={employeeDetails?.DesignationId}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode
                    ? employeeDetails?.DesignationName
                    : "Select Designation"}
                </option>
                {designation?.map((g) => (
                  <option key={g.value} value={g.Id}>
                    {g.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group md:col-span-4 col-span-12">
              <label>
                Employee Status <span style={{ color: "red" }}> *</span>
              </label>
              <select
                disabled={isEdit}
                name="EmpStatus"
                value={employeeDetails?.EmpStatus || ""}
                onChange={handleInputChange}
                required
              >
                <option value="">
                  {isEditMode
                    ? employeeDetails?.EmpStatus
                    : "Select EmployeeStatus"}
                </option>
                {empType?.map((el, index) => (
                  <option key={index} value={el.ID}>
                    {el.type}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group flex col-span-4 flex-col">
              <label className="flex items-center space-x-1">
                <span>Default shift</span>
                <span className="text-red-500">*</span>
              </label>
              <select
                disabled={isEdit}
                name="ShiftId"
                value={employeeDetails?.ShiftId || ""}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a shift</option>
                {shiftData?.map((shift) => (
                  <option key={shift.Id} value={shift.Id}>
                    {shift.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group flex col-span-4 flex-col">
              <label className="flex items-center space-x-1">
                Allow Mobile Punch
              </label>

              <select
                disabled={isEdit}
                name="MobilePunch"
                value={employeeDetails?.MobilePunch ?? "0"}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "MobilePunch", value: e.target.value },
                  })
                }
              >
                <option value="0">No Punch</option>
                <option value="1">Allow Within the Radius</option>
                <option value="2">Allow Anywhere</option>
              </select>
            </div>
            <div className="form-group col-span-4 mt-4 flex items-center space-x-4">
              <label className="text-gray-700 font-medium select-none flex items-center space-x-1">
                <span>Duty Allocation</span>
              </label>
              <input
                disabled={isEdit}
                type="checkbox"
                name="DutyAllocation"
                checked={employeeDetails?.DutyAllocation || false}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "DutyAllocation", value: e.target.checked },
                  })
                }
                className="form-checkbox h-6 w-6 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
            </div>

            <div className="form-group flex col-span-4 flex-col">
              <label className="flex items-center space-x-1">
                Direct Deduct HalfDay <span className="text-red-500">*</span>
              </label>

              <select
                disabled
                name="directHalfday"
                required
                value={employeeDetails?.directHalfday ?? ""}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "directHalfday", value: e.target.value },
                  })
                }
              >
                <option value="">choose one</option>
                <option value="0">With Permission</option>
                <option value="1">direct deduct</option>
              </select>
            </div>

            <div className="form-group md:col-span-4 col-span-12">
              <label>Remarks</label>
              <input
                disabled={isEdit}
                type="text"
                name="Remarks"
                value={employeeDetails?.Narration}
                onChange={handleInputChange}
                placeholder="Remarks"
              />
            </div>
          </div>

          <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
            <button
              type="button"
              onClick={ClearEmployeeData}
              className="btn btn-outline-secondary"
            >
              Clear
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={
                loading || isEdit || Object.values(errors).some((err) => err)
              }
            >
              {loading
                ? "Loading..."
                : employeeDetails.Id
                  ? "Update Employee"
                  : "Add Employee"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EmployeeDetails;
